<template>
    <div class="mb-3">
        <h5>
            {{ $t('general.authSuccess') }}
            <br />
            {{ $t('general.pressToDownload') }}
            {{ $t('general.pressToDownload') }}
            <a ref="certLink" :href="`data:application/x-pkcs12;charset=utf-8;base64,${downloadUrl}`" :download="`${certificateName}.p12`">{{ $t('general.here') }}</a>.
        </h5>
        {{ $t('general.pressToLogin', [this.$t('general.next')]) }}
    </div>
</template>

<script>
export default {
    name: 'Authenticated',
    props: {
        downloadUrl: String,
        certificateName: String
    },
    mounted () {
        if (this.downloadUrl.length > 0) {
            this.$refs.certLink.click()
        }
    }
}
</script>
